class RichRelevanceCartInstrumentationController {

    constructor($window, richRelevanceService) {

        richRelevanceService.getInformation()
            .then(() => {
                $window.R3_CART = new $window.r3_cart(); // eslint-disable-line new-cap

                this.products.forEach((product) => {
                    $window.R3_CART.addItemId(product.Stockcode);
                });

                $window.rr_flush_onload();
                $window.r3();
            });
    }
}

const richRelevanceCartInstrumentationComponentDefinition = {
    controller: ['$window', 'RichRelevanceService', RichRelevanceCartInstrumentationController],
    bindings: {
        products: '<',
    },
};

module.exports = {
    RichRelevanceCartInstrumentationController,
    richRelevanceCartInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-cart-instrumentation.component.js